import { tempStatusIconSrc, statusMap, tempStatusMetaMaps, metaIconSrc } from '@utils/tempStatusUtils'
import { size, colors as themeColors } from '@styles/theme'
import { isOnlineOrRecent } from '@utils/isOnlineOrRecent'
import { MapData } from '@contexts/mapDataContext'

const colors = {
  browsing: '#3750bf',
  // Various shades of grey...
  // browsing: '#333333',
  // browsing: '#191c2b',
  // browsing: '#22263b',
  // browsing: '#3d4469',
  // browsing: '#576299',
  right_now: '#6A23FF',
  meetup: '#E3B100',
  chatting: '#2F9BE9',
  // romance: '#C154C1',
  // romance: '#B43389',
  // romance: '#910692',
  romance: '#9400D3',
}

const tempStatusLayoutMap = {
  0: {
    top: '30%',
    left: '-12.5%',
  },
  1: {
    top: '55%',
    left: '-9%',
  },
}

const circleDiv = (sizing) => {
  const element = document.createElement('div')
  element.style.height = size(sizing)
  element.style.width = size(sizing)
  element.style.borderRadius = '100%'
  element.style.relative = 'relative'
  return element
}

const circleImg = (sizing, isAvatar) => {
  const element = document.createElement('img')
  element.style.height = size(sizing)
  element.style.width = size(sizing)
  // NOTE: The greyscale avatar variants aren't bad, but they're a bit boring. I think they would drop user engagement...
  // if (isAvatar) element.style.filter = 'grayscale(40%) contrast(90%)'
  // if (isAvatar) element.style.filter = 'grayscale(70%) contrast(140%) brightness(80%)'
  element.style.borderRadius = '100%'
  return element
}

const backgroundCircleEl = ({ data, isAvatar, sizing, backgroundSizeAdd, hasEntranceAnimation }) => {
  // BACKGROUND CIRCLE
  const backgroundCircle = circleDiv(isAvatar ? sizing*0.75 + backgroundSizeAdd*0.75 : sizing + backgroundSizeAdd)
  backgroundCircle.classList.add('profile-marker')
  backgroundCircle.style.backgroundColor = colors[data.tempStatus] || colors['browsing']
  backgroundCircle.style.position = 'relative'
  backgroundCircle.style.display = 'flex'
  backgroundCircle.style.alignItems = 'center'
  backgroundCircle.style.justifyContent = 'center'
  backgroundCircle.style.transform = 'translate(-50%, -50%)'

  if (hasEntranceAnimation) {
    backgroundCircle.style.animation = 'growInCenteredXY 500ms'
    setTimeout(() => {
      backgroundCircle.style.animation = ''
    }, 1000)
  }

  backgroundCircle.addEventListener('click', (e) => {
    e.preventDefault()
    if (typeof MapData.navigateFunc.value === 'function') {
      MapData.navigateFunc.value({ pathname: '/map', search: { nearby_uuid: data?.nearbyUuid } }, { state: { user: JSON.stringify(data) } })
    }
  })

  return backgroundCircle
}

const registeredTagEl = ({ data, isAvatar, sizing=8 }) => {
  // REGISTERED TAG
  const registeredTag = document.createElement('div')
  registeredTag.style.height = isAvatar ? '0.85rem' : '1.25rem'
  registeredTag.style.width = isAvatar ? '0.85rem' : '1.25rem'
  registeredTag.style.position = 'absolute'
  registeredTag.style.right = isAvatar ? '-0.75rem' : '-1rem'
  registeredTag.style.top = size((isAvatar ? sizing/3.25 : sizing/2.5))
  registeredTag.style.borderRadius = '0 100px 100px 0'
  registeredTag.style.backgroundColor = colors[data.tempStatus] || colors['browsing']
  registeredTag.style.display = 'flex'
  registeredTag.style.alignItems = 'center'
  registeredTag.style.justifyContent = 'center'

  // REGISTERED ICON
  const registeredIcon = document.createElement('img')
  let iconType = 'mask'
  if (!data.isAnonymous) iconType = 'person'
  if (data.isSubscribed) iconType = 'subscribed'
  if (data.travelModeEnabledAt) iconType = 'traveling'
  registeredIcon.src = `https://mandrake-app.b-cdn.net/dev/application/icons/${iconType}.svg`
  registeredIcon.style.width = isAvatar ? '0.5rem' : '0.75rem'
  registeredIcon.style.height = isAvatar ? '0.5rem' : '0.75rem'
  registeredIcon.style.opacity = '75%'
  registeredTag.appendChild(registeredIcon)
  return registeredTag
}

const youTagEl = ({ data, isAvatar, sizing }) => {
  // YOU TAG
  const youTag = document.createElement('div')
  youTag.style.height = isAvatar ? '0.85rem' : '1.25rem'
  youTag.style.width = isAvatar ? '1.75rem' : '2rem'
  youTag.textContent = 'you'
  youTag.style.paddingRight = isAvatar ? '0.25rem' : '0.3rem'
  youTag.style.display = 'flex'
  youTag.style.fontSize = '8px'
  youTag.style.lineHeight = '8px'
  youTag.style.fontWeight = '600'
  youTag.style.paddingBottom = '2px'
  youTag.style.alignItems = 'center'
  youTag.style.justifyContent = 'flex-end'
  youTag.style.borderRadius = '0 100px 100px 0'
  youTag.style.backgroundColor = colors[data.tempStatus] || colors['browsing']
  youTag.style.position = 'absolute'
  youTag.style.right = isAvatar ? '-2rem' : '-2.3rem'
  youTag.style.top = size((isAvatar ? sizing/3.25 : sizing/2.5))
  youTag.style.zIndex = '-1'
  return youTag
}

const statusTagEl = ({ data, isAvatar }) => {
  // STATUS TAG
  const statusTag = document.createElement('div')
  statusTag.style.height = isAvatar ? '1.35rem' : '1.75rem'
  statusTag.style.width = isAvatar ? '1.35rem' : '1.75rem'
  statusTag.style.position = 'absolute'
  statusTag.style.left = isAvatar ? '-0.2rem' : '-0.25rem'
  statusTag.style.top = isAvatar ? size(-0.35) : size(-0.5)
  statusTag.style.borderRadius = '100px 100px'
  statusTag.style.backgroundColor = colors[data.tempStatus] || colors['browsing']
  statusTag.style.display = 'flex'
  statusTag.style.alignItems = 'center'
  statusTag.style.justifyContent = 'center'
  statusTag.style.zIndex = '2'

  // STATUS ICON
  const statusIcon = document.createElement('img')
  statusIcon.src = tempStatusIconSrc(data?.tempStatus)
  statusIcon.style.width = isAvatar ? '0.9rem' : '1.1rem'
  statusIcon.style.height = isAvatar ? '0.9rem' : '1.1rem'
  statusTag.appendChild(statusIcon)
  return statusTag
}

const profileCircleEl = ({ isAvatar, sizing, profileImage }) => {
  // PROFILE IMAGE CIRCLE
  const profileCircle = circleImg((isAvatar ? sizing*0.75 : sizing), isAvatar)
  profileCircle.setAttribute('src', profileImage)
  profileCircle.style.border = `1px solid #rgba(255,255,255,0.1)`
  profileCircle.style.borderRadius = `100px`
  profileCircle.style.zIndex = `1`
  profileCircle.classList.add('user-avatar')
  return profileCircle
}

const onlineIndicatorEl = ({ data, isAvatar, sizing }) => {
  const onlineIndicator = document.createElement('div')
  onlineIndicator.style.height = isAvatar ? '0.6rem' : '0.8rem'
  onlineIndicator.style.width = isAvatar ? '0.6rem' : '0.8rem'
  onlineIndicator.style.position = 'absolute'
  onlineIndicator.style.right =  '-0.125rem'
  onlineIndicator.style.top = size((isAvatar ? sizing/6 : sizing/4.5))
  onlineIndicator.style.borderRadius = '100px'
  onlineIndicator.style.border = '0.5px solid rgba(200,200,200, 0.5)'
  onlineIndicator.style.boxShadow = '1px 1px 1px rgba(0,0,0, 0.75)'
  onlineIndicator.style.backgroundColor = themeColors.statusColors[data.tempStatus]('light') || themeColors.statusColors.browsing('light')
  // onlineIndicator.style.backgroundColor = '#7EF4E1'
  onlineIndicator.style.zIndex = '2'
  return onlineIndicator
}

const newMessageFilter = () => (
' brightness(0) saturate(100%) invert(91%) sepia(16%) saturate(755%) hue-rotate(107deg) brightness(100%) contrast(89%) '
)

const dropShadowFilter = () => (
  'drop-shadow(2px 1px 2px rgba(0,0,0,1))'
)

const chatEl = ({ data, isAvatar, sentOrReply }) => {
  if (!data?.lastMessage?.nearbyUuid) return;

  // TAG
  const chatTag = document.createElement('div')
  chatTag.style.height = isAvatar ? '1.35rem' : '1.75rem'
  chatTag.style.width = isAvatar ? '1.35rem' : '1.75rem'
  chatTag.style.position = 'absolute'
  chatTag.style.right =  '-0.1rem'
  chatTag.style.bottom = '0.15rem'
  chatTag.style.borderRadius = '100px 100px'
  chatTag.style.display = 'flex'
  chatTag.style.alignItems = 'center'
  chatTag.style.justifyContent = 'center'
  chatTag.style.zIndex = '2'

  // CHAT ICON
  const chatIcon = document.createElement('img')
  chatIcon.src = `https://mandrake-app.b-cdn.net/dev/application/icons/${sentOrReply}.svg`
  chatIcon.style.width = isAvatar ? '0.9rem' : '1.1rem'
  chatIcon.style.height = isAvatar ? '0.9rem' : '1.1rem'
  chatIcon.style.filter = dropShadowFilter()
  if (sentOrReply == 'reply' && data?.lastMessage?.isNew) {
    chatIcon.style.filter = newMessageFilter() + dropShadowFilter()
  }
  chatTag.appendChild(chatIcon)
  return chatTag
}

const metaEl = ({ data, isAvatar, accessor }) => {
  // META TAG
  const metaTag = document.createElement('div')
  metaTag.style.height = isAvatar ? '0.9rem' : '1.1rem'
  metaTag.style.width = isAvatar ? '0.9rem' : '1.1rem'
  metaTag.style.position = 'absolute'
  metaTag.style.borderRadius = '100px 100px'
  metaTag.style.backgroundColor = colors[data.tempStatus] || colors['browsing']
  metaTag.style.display = 'flex'
  metaTag.style.alignItems = 'center'
  metaTag.style.justifyContent = 'center'
  metaTag.style.zIndex = '2'

  // META ICON
  const metaIcon = document.createElement('img')
  metaIcon.src = `https://mandrake-app.b-cdn.net/dev/application/icons/${tempStatusMetaMaps[accessor][data.tempStatusMeta[accessor]]}.svg`
  metaIcon.src = metaIconSrc(accessor, data.tempStatusMeta[accessor])
  metaIcon.style.width = isAvatar ? '0.6rem' : '0.75rem'
  metaIcon.style.height = isAvatar ? '0.6rem' : '0.75rem'
  metaTag.appendChild(metaIcon)
  return metaTag
}

  ////////////////////////////
 // PROFILE MARKER FACTORY //
////////////////////////////
const profileMarker = (
  data,
  {
    hasEntranceAnimation=true,
    backgroundSizeAdd=0.75,
    isCurrentUser,
    profileImage,
    isFocused,
    isAvatar,
    sizing=8,
  }) => {

  // MAIN BACKGROUND CIRCLE
  const backgroundCircle = backgroundCircleEl({
    data,
    isAvatar,
    sizing,
    backgroundSizeAdd,
    hasEntranceAnimation,
  })

  if (isFocused) {
    backgroundCircle.style.boxShadow = `0 0 0px 5px ${themeColors.statusColors[data.tempStatus]('lightRgba')(0.5)}`
  }

  // REGISTERED TAG
  const registeredTag = registeredTagEl({ data, isAvatar, sizing })
  backgroundCircle.appendChild(registeredTag)

  // YOU TAG
  if (isCurrentUser) {
    const youTag = youTagEl({ data, isAvatar, sizing })
    backgroundCircle.appendChild(youTag)
  }

  // STATUS TAG
  if (data.tempStatus && data.tempStatus !== 'browsing') {
    const statusTag = statusTagEl({ data, isAvatar })
    backgroundCircle.appendChild(statusTag)
  }

  // META TAGS
  const metaTags = []
  if (data.tempStatus === 'right_now') {
    if (data?.tempStatusMeta?.position) {
      const positionTag = metaEl({ data, isAvatar, accessor: 'position' })
      metaTags.push(positionTag)
    }
    if (data?.tempStatusMeta?.hosting) {
      const hostingTag = metaEl({ data, isAvatar, accessor: 'hosting' })
      metaTags.push(hostingTag)
    }
    metaTags.forEach((tag, index) => {
      tag.style.top = tempStatusLayoutMap[index]?.top
      tag.style.left = tempStatusLayoutMap[index]?.left
      backgroundCircle.appendChild(tag)
    })
  }

  // PROFILE IMAGE CIRCLE
  const profileCircle = profileCircleEl({ isAvatar, sizing, profileImage })

  const { isOnline, isRecent } = isOnlineOrRecent(data)
  if (isCurrentUser || isOnline || isRecent) {
    const onlineIndicator = onlineIndicatorEl({ data, isAvatar, sizing })
    backgroundCircle.appendChild(onlineIndicator)
  }
  
  if (data?.lastMessage) {
    let sentOrReply = data.lastMessage?.nearbyUuid === data.nearbyUuid ? 'reply' : 'sent'
    const chatTag = chatEl({ data, isAvatar, sizing, sentOrReply })
    if (chatTag) backgroundCircle.appendChild(chatTag)
  }

  backgroundCircle.appendChild(profileCircle)
  return backgroundCircle
}

export default profileMarker
